import React from 'react'
import { Container, Box, Flex } from 'theme-ui'
import { FooterIcon } from './Footer.Icon'
import { FooterMenu } from './Footer.Menu'
// import { FooterSocial } from './Footer.Social'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `footerBg`,
    mt: [0] // [5, 6]
  }
  // icon: {
  //   position: 'absolute',
  //   top: '50%',
  //   transform: 'translateY(-50%)'
  // }
}

export const Footer = () => (
  <Box sx={styles.wrapper}>
    <Container variant='compact' sx={styles.container}>
      <Flex variant='layout.footer'>
        <Box>
          <FooterIcon />
        </Box>
        <Box></Box>
        <FooterMenu />
        {/*<Box>
          <FooterSocial />
        </Box>*/}
      </Flex>
    </Container>
  </Box>
)
